<formly-form
[form]="form"
[fields]="formFields"
[model]="formModel">
</formly-form>